import { Container, EmptyState, WorkOfficeDesk } from '@/components';
import { useMarketsView } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { MarketsDetails } from './markets-details';
import { useCountries } from '@/hooks';

export function MarketsView() {
  const { t } = useTranslation(['insights']);
  const markets = useMarketsView();
  const { options: countries } = useCountries();

  return (
    <Container size="xl">
      <div className="flex flex-col space-y-3 px-4 py-6">
        {markets?.length ? (
          <MarketsDetails markets={markets} countries={countries} />
        ) : (
          <EmptyState
            artwork={<WorkOfficeDesk className="w-64" />}
            title={t('Market Insights: Coming Soon!')}
            description={t(
              'Exclusive market insights for Business users coming soon, featuring data, trends, and analysis to support your investment decisions.'
            )}
          ></EmptyState>
        )}
      </div>
    </Container>
  );
}
